import { customFetch } from "@/client/custom-fetch";

import { IRegisterRequest, IRegisterResponse } from "./register.types";

export const registerApi = {
  register: (data: IRegisterRequest): Promise<IRegisterResponse> => {
    return customFetch<IRegisterResponse>("/user", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "g-recaptcha-response": data.reCaptchaToken || "",
      },
      body: JSON.stringify({
        name: data.name,
        email: data.email,
        password: data.password,
        userType: data.userType,
      }),
    });
  },
  registerSimple: (data: IRegisterRequest): Promise<IRegisterResponse> => {
    return customFetch<IRegisterResponse>("/user/simple", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "g-recaptcha-response": data.reCaptchaToken || "",
      },
      body: JSON.stringify({
        name: data.name,
        email: data.email,
        userType: data.userType,
      }),
    });
  },
};
